// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobilenavigationbar_mobileContainer__EfZjY {
  max-width: 480px;
  margin: auto;
  color: white;
  border-radius: 0px;
      border-bottom: 1px solid var(--hsrcMidBlue);

}

.mobilenavigationbar_topnav__Y-zlL {
  overflow: hidden;
  position: relative;
}

.mobilenavigationbar_topnav__Y-zlL #mobilenavigationbar_myLinks__BvQQV {
  display: none;

}

.mobilenavigationbar_topnav__Y-zlL a {
  color: white;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 17px;
  display: block;
  border-bottom: 0.3px solid var(--hsrcMidBlue);
}

.mobilenavigationbar_burgerIcon__jgBXN {
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  color:var(--hsrcOrange);
  padding-top:5px;
  height:50px;
  width:50px;
}

.mobilenavigationbar_topnav__Y-zlL a:hover {
  color: var(--hsrcOrange);
  color: var(--hsrcWhite);
    background-color:var(--hsrcOrange);

}

.mobilenavigationbar_active__2hqoZ {
  color: white;
}

.mobilenavigationbar_hsrc__logo__d\\+DJo{
    padding-left:10px;
    padding-top:5px;
}`, "",{"version":3,"sources":["webpack://./src/components/NavigationBar/mobilenavigationbar.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;MACd,2CAA2C;;AAEjD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;;AAEf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;IACrB,kCAAkC;;AAEtC;;AAEA;EACE,YAAY;AACd;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":[".mobileContainer {\r\n  max-width: 480px;\r\n  margin: auto;\r\n  color: white;\r\n  border-radius: 0px;\r\n      border-bottom: 1px solid var(--hsrcMidBlue);\r\n\r\n}\r\n\r\n.topnav {\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.topnav #myLinks {\r\n  display: none;\r\n\r\n}\r\n\r\n.topnav a {\r\n  color: white;\r\n  padding: 14px 16px;\r\n  text-decoration: none;\r\n  font-size: 17px;\r\n  display: block;\r\n  border-bottom: 0.3px solid var(--hsrcMidBlue);\r\n}\r\n\r\n.burgerIcon {\r\n  display: block;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  color:var(--hsrcOrange);\r\n  padding-top:5px;\r\n  height:50px;\r\n  width:50px;\r\n}\r\n\r\n.topnav a:hover {\r\n  color: var(--hsrcOrange);\r\n  color: var(--hsrcWhite);\r\n    background-color:var(--hsrcOrange);\r\n\r\n}\r\n\r\n.active {\r\n  color: white;\r\n}\r\n\r\n.hsrc__logo{\r\n    padding-left:10px;\r\n    padding-top:5px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobileContainer": `mobilenavigationbar_mobileContainer__EfZjY`,
	"topnav": `mobilenavigationbar_topnav__Y-zlL`,
	"myLinks": `mobilenavigationbar_myLinks__BvQQV`,
	"burgerIcon": `mobilenavigationbar_burgerIcon__jgBXN`,
	"active": `mobilenavigationbar_active__2hqoZ`,
	"hsrc__logo": `mobilenavigationbar_hsrc__logo__d+DJo`
};
export default ___CSS_LOADER_EXPORT___;
